<template>
    <v-app>
        <v-layout row wrap>
            <v-flex xs8>
                <v-form ref="form" lazy-validation>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-select @change="addressOnChange" :items="addresses" item-text="address_name" label="Addresses"></v-select>
                            <v-text-field v-model="form.firstName" label="First Name" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.surname" label="Surname" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.address1" label="Address 1" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.address2" label="Address 2"></v-text-field>
                            <v-text-field v-model="form.city" label="City" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.postcode" label="Postcode" :rules="rules" required></v-text-field>
                            <v-select v-model="form.country" :items="countryOptions" :rules="rules" label="Please select a country"></v-select>
                        </v-flex>
                        <v-flex xs1></v-flex>
                        <v-flex xs4>
                            <v-text-field v-model="form.amount" label="Amount" :rules="rules" required></v-text-field>
                            <v-select v-model="form.currency" :items="selectedChannel.currencies" :rules="rules" required label="Please select a currency"></v-select>
                            <!--<v-autocomplete v-model="form.currency" :items="selectedEntity.currencies" :rules="rules" label="Please select a currency"></v-autocomplete>-->
                            <v-select v-model="form.recurringType" :items="recurringTypeOptions" :rules="rules" required label="Please select a recurring type"></v-select>
                            
                            <v-flex xs12 text-xs-right row id="form-btns" class="pr-0">
                                <v-btn @click="onReset" color="error">Reset</v-btn>
                                <v-btn  @click="onSubmit" color="primary mr-0" >Submit</v-btn>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                 </v-form>
            </v-flex>

            <v-flex xs4>
                <form v-if="host == 'localhost'" action="http://localhost:8080/eterminal" class="paymentWidgets" data-brands="VISA MASTER AMEX APPLEPAY"></form>
                <form v-else action="https://management.totalprocessing.com/eterminal" class="paymentWidgets" data-brands="VISA MASTER AMEX APPLEPAY"></form>
            </v-flex>
        </v-layout>
    </v-app>
</template>

<script>
    import axios from 'axios';

    export default {
        data () {
            return {
                rules: [
                    v => !!v || 'Required field'
                ],
                form: {
                    firstName: null,
                    surname: null,
                    address1: null,
                    address2: null,
                    city: null,
                    postcode: null,
                    country: null,
                    amount: null,
                    currency: null,
                    recurringType: null
                },
                countryOptions: [
                    { value: 'AU', text: 'Australia' },
                    { value: 'CA', text: 'Canada' },
                    { value: 'CN', text: 'China' },
                    { value: 'FR', text: 'France' },
                    { value: 'DE', text: 'Germany' },
                    { value: 'IN', text: 'India' },
                    { value: 'JP', text: 'Japan' },
                    { value: 'SP', text: 'Spain' },
                    { value: 'GB', text: 'United Kingdom' },
                    { value: 'US', text: 'United States' }
                ],
                currencyOptions: this.selectedChannel.currencies,
                recurringTypeOptions: [
                    { value: 'NONE', text: 'NONE' },
                    { value: 'INITIAL', text: 'INITIAL' },
                    { value: 'REPEATED', text: 'REPEATED' }
                ],
                checkoutId: null,
                address: null,
                host: window.location.hostname
            }
        },
        props: {
            paymentType: String,
            selectedChannel: Object,
            addresses: Array
        },
        computed: {
            sortedCurrencies: function() {
                function compare(a, b) {
                    if (a.text < b.text)
                    return -1;
                    if (a.text > b.text)
                    return 1;
                    return 0;
                }
                return this.currencyOptions.sort(compare);
            },
        },
        methods: {
            onSubmit(e) {
                e.preventDefault();

                if (this.$refs.form.validate()) {
                    axios({
                        method: 'post',
                        url: 'https://controlapi.totalprocessing.com/api/process-request',
                        data: { form: this.form, channel: this.selectedChannel, paymentType: this.paymentType, userId: localStorage.user_id },
                        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                        })
                        .then(response => {
                            const copyAndPayScript = document.createElement('script');
                            this.checkoutId = response.data.id;
                            console.log(response.data);

                            if(this.paymentType == 1 || this.paymentType == 2) {
                                copyAndPayScript.setAttribute('src', 'https://oppwa.com/v1/paymentWidgets.js?checkoutId='+this.checkoutId);
                                document.head.appendChild(copyAndPayScript);
                            }
                        })
                        .catch(e => {
                            this.errors.push(e)
                    })
                }
            },
            onReset(e) {
                this.$refs.form.reset();
            },
            addressOnChange(e) {

                if(e) {
                    this.address = this.addresses.find(x => x.address_name === e);
                    this.form.firstName = this.address.first_name;
                    this.form.surname = this.address.surname;
                    this.form.address1 = this.address.address_1;
                    this.form.address2 = this.address.address_2;
                    this.form.city = this.address.city;
                    this.form.postcode = this.address.postcode;
                    this.form.country = this.address.country;
                }
                else {
                    this.form.firstName = null;
                    this.form.surname = null;
                    this.form.address1 = null;
                    this.form.address2 = null;
                    this.form.city = null;
                    this.form.postcode = null;
                    this.form.country = null;
                }

            }
        }
    }
</script>

<style>
    #form-btns {
        margin-top: 1px;
    }

    .error--text > .v-messages__wrapper > .v-messages__message {
        font-size: 10px;
    }
</style>